/**
 * Maps elements of an iterable to a new array, filtering out null and undefined values.
 * @util
 *
 * @template T1 - The type of elements in the input iterable
 * @template T2 - The type of elements in the output array
 * @param array - The input iterable to map over
 * @param map - The function to apply to each element, which may return null or undefined
 * @returns An array containing only the non-null mapped values
 */
export function mapNotNull(array, map) {
    const result = [];
    let i = 0;
    for (const item of array) {
        const mapped = map(item, i++);
        if (mapped != null) {
            result.push(mapped);
        }
    }
    return result;
}
//# sourceMappingURL=mapNotNull.js.map